import * as React from "react";
import { useState } from "react";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import Modal from "components/Modal";
import { verifyKyc } from "egold/api";
import { kycData } from "./kycData";
import Form from "myshubhlife-component/form";
import Loading from "components/loading";
import Button from "myshubhlife-component/button";
import { setKycStatus, showToast } from "egold/actions";
import { IEgoldUserDetails } from "StateInterface";
import { useEffect } from "react";
import { ToastBgColor } from "egold/utils";
import "./style.scss"
import {unFlattenForm} from "utils";

const errorMessage = "We couldn't verify your PAN card details";
interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    userDetails: IEgoldUserDetails;
}
interface IProps {
    active: boolean;
    handleClose?: () => void;
    handleProceed?: () => void;
}
type finalProps = IConnectProps & IProps;
const KycValidation = (props: finalProps) => {
    const [inputDetails, updateInputDetails] = useState(kycData);
    const [loading, setLoading] = useState(false);
    const [error, setErrors] = useState({status: false, msg: ""});
    useEffect(() => {
        if (props.userDetails && props.userDetails.is_kyc_verified) {
            props.handleClose();
            props.handleProceed();
        }
    }, [props.userDetails && props.userDetails.is_kyc_verified]);
    const  onFormSubmit = () => {
        const kycDetails = unFlattenForm(inputDetails.fields)[0];
        setLoading(true);
        verifyKyc(props.userId, kycDetails.pan, kycDetails.dob)
            .then((res) => {
            setLoading(false); 
            if (res.data.status) {
                props.dispatch(setKycStatus(kycDetails.pan));
                props.dispatch(showToast(ToastBgColor.GREEN, "PAN verification successful"));
                props.handleClose();
            } else {
                setErrors({
                    status: true,
                    msg: errorMessage,
                });
            }
        })
        .catch((err) => {
            setLoading(false);
            setErrors({
                status: true,
                msg: errorMessage,
            });
        });
    };
    const onFormChange = (index: number,
                          value: string | number | string[] | boolean,
                          formIndex: number, fieldName: string) => {
        updateInputDetails((prevState) => ({...prevState,
        fields: [...prevState.fields.slice(0, formIndex), {...prevState.fields[formIndex],
        fields: [ ...prevState.fields[formIndex].fields.slice(0, index), {...prevState.fields[formIndex].fields[index],
        [fieldName]: index === 0 && fieldName === "value" ? value.toString().toUpperCase() : value},
        ...prevState.fields[formIndex].fields.slice(index + 1)]}, ...prevState.fields.slice(formIndex + 1)]}));
      };
    const handleClose = () => {
        props.handleClose();
        setErrors({
            status: false,
            msg: "",
        });
      };
    return(
        <div className="kyc-modal">
            <Modal
                title={"Verify Pan Details"}
                active={props.active}
                cancellable={true}
                onClose={handleClose}
                disableFooter={true}
            >
                <Loading active={loading} msg={"Verifying your PAN details"} />
                {
                    error.status ?
                    <div>
                        <div className="kyc-error-message">
                            {error.msg}
                        </div>
                        <Button buttonText={"Cancel"}
                        onClick={handleClose}
                        maxWidth={200}
                         />
                    </div> :
                <Form formData={inputDetails}
                    onFormSubmit={onFormSubmit}
                    onFormChange={onFormChange}
                />
                }
            </Modal>
        </div>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth.userId,
        userDetails: state.eGold.eGoldUserDetails,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(KycValidation);
